export default "/settings/hooks"
